import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import a1 from '../../../assets/afterbefore/a1.webp'
import a2 from '../../../assets/afterbefore/a2.webp'
import a4 from '../../../assets/afterbefore/a4.webp'
import a5 from '../../../assets/afterbefore/a5.webp'
import a6 from '../../../assets/afterbefore/a6.webp'
import a7 from '../../../assets/afterbefore/a7.webp'
import a8 from '../../../assets/afterbefore/a8.webp'
import a9 from '../../../assets/afterbefore/a9.webp'
import a10 from '../../../assets/afterbefore/a10.webp'
import a11 from '../../../assets/afterbefore/a11.webp'
import a12 from '../../../assets/afterbefore/a12.webp'
import a13 from '../../../assets/afterbefore/a13.webp'
import a14 from '../../../assets/afterbefore/a14.webp'
import a15 from '../../../assets/afterbefore/a15.webp'
import a16 from '../../../assets/afterbefore/a16.webp'
import a17 from '../../../assets/afterbefore/a17.webp'
import a18 from '../../../assets/afterbefore/a18.webp'
import a19 from '../../../assets/afterbefore/a19.webp'
import a20 from '../../../assets/afterbefore/a20.webp'
import a21 from '../../../assets/afterbefore/a21.webp'

const Afterbefore = () => {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 768, // Adjust this breakpoint as needed
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }
  return (
    <>
      <div className="after_before my-5">
        <Container>
          <Row>
            <Col md={12}>
              <div className="Button_healthy mb-5">
                <span className="lets">See the Changes: Before & After</span>
              </div>
              <div className="main_head mt-5">
                <h2></h2>
              </div>
              <div className="main_p mt-3">
                <p>
                  Explore the amazing results of our treatments with
                  side-by-side images. Watch as our procedures breathe new life
                  into your appearance, making you look and feel your best.
                </p>
                <p>
                  Visit our gallery and get a sneak peek into the realm of
                  cutting-edge healthcare at Sharva Clinic. From cutting-edge
                  treatment centers to empathetic patient support, our visuals
                  highlight our dedication to quality. Observe our team of
                  skilled physicians in Delhi providing customized therapies and
                  changing lives. Your well-being is our top concern, and we aim
                  to deliver the finest medical treatment with accuracy and
                  empathy.
                </p>
              </div>
            </Col>
          </Row>

          <div className="gallery_slider">
            <Slider {...settings}>
              <div className="improve_images">
                <img src={a1} alt="improve_image" />
              </div>
              <div className="improve_images">
                <img src={a2} alt="improve_image" />
              </div>
              <div className="improve_images">
                <img src={a4} alt="improve_image" />
              </div>
              <div className="improve_images">
                <img src={a5} alt="improve_image" />
              </div>
              <div className="improve_images">
                <img src={a6} alt="improve_image" />
              </div>
              <div className="improve_images">
                <img src={a7} alt="improve_image" />
              </div>
              <div className="improve_images">
                <img src={a8} alt="improve_image" />
              </div>
              <div className="improve_images">
                <img src={a9} alt="improve_image" />
              </div>
              <div className="improve_images">
                <img src={a10} alt="improve_image" />
              </div>
              <div className="improve_images">
                <img src={a11} alt="improve_image" />
              </div>
              <div className="improve_images">
                <img src={a12} alt="improve_image" />
              </div>
              <div className="improve_images">
                <img src={a13} alt="improve_image" />
              </div>
              <div className="improve_images">
                <img src={a20} alt="improve_image" />
              </div>
              <div className="improve_images">
                <img src={a15} alt="improve_image" />
              </div>
              <div className="improve_images">
                <img src={a16} alt="improve_image" />
              </div>
              <div className="improve_images">
                <img src={a17} alt="improve_image" />
              </div>
              <div className="improve_images">
                <img src={a18} alt="improve_image" />
              </div>
              <div className="improve_images">
                <img src={a19} alt="improve_image" />
              </div>
              <div className="improve_images">
                <img src={a21} alt="improve_image" />
              </div>
            </Slider>
          </div>
        </Container>
      </div>
    </>
  )
}

export default Afterbefore
